import { formatCellValue, TruncatedText } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { ContractPickup } from "@/lib/coach-manager/types";

export function PickupsTable({ pickups }: { pickups: ContractPickup[] }) {
  if (pickups.length === 0) return null;

  return (
    <DataTable
      headers={[
        { label: "Pickup Point" },
        { label: "Arrival Day" },
        { label: "Arrival Time" },
        { label: "Pickup Day" },
        { label: "Pickup Time" },
        { label: "Latitude" },
        { label: "Longitude" },
        { label: "Instructions" },
      ]}
    >
      {pickups.map((pickup) => (
        <tr key={pickup.ContractPickupID} className="border-b last:border-b-0">
          <td className="px-4 py-2">{formatCellValue(pickup.PickupPoint)}</td>
          <td className="px-4 py-2">{pickup.ArrivalDayNo}</td>
          <td className="px-4 py-2">{formatCellValue(pickup.ArrivalTime)}</td>
          <td className="px-4 py-2">{pickup.PickupDayNo}</td>
          <td className="px-4 py-2">{formatCellValue(pickup.PickupTime)}</td>
          <td className="px-4 py-2">{formatCellValue(pickup.Latitude)}</td>
          <td className="px-4 py-2">{formatCellValue(pickup.Longitude)}</td>
          <td className="px-4 py-2">
            <TruncatedText value={pickup.Instructions} />
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
